<template lang="pug">
b-tr.usage-fees-tokuyo-care-insurance-service-costs-table-row
  b-td.room-name {{ roomName }}
  b-td
    .d-flex.flex-row.align-items-center
      b-form-input.mr-1(v-model.number="_value.careLevel_1"
        :name="'usage-fees-tokuyo-' + roomId + '-care-level-1'"
        :maxlength="10" :class="[ { noinput: _value.careLevel_1 == null } ]"
        v-validate="{ required: true, max: 10 }" :data-vv-as="roomName + 'の要介護1'")
      span 円
  b-td
    .d-flex.flex-row.align-items-center
      b-form-input.mr-1(v-model.number="_value.careLevel_2"
        :name="'usage-fees-tokuyo-' + roomId + '-care-level-2'"
        :maxlength="10" :class="[ { noinput: _value.careLevel_2 == null } ]"
        v-validate="{ required: true, max: 10 }" :data-vv-as="roomName + 'の要介護2'")
      span 円
  b-td
    .d-flex.flex-row.align-items-center
      b-form-input.mr-1(v-model.number="_value.careLevel_3"
        :name="'usage-fees-tokuyo-' + roomId + '-care-level-3'"
        :maxlength="10" :class="[ { noinput: _value.careLevel_3 == null } ]"
        v-validate="{ required: true, max: 10 }" :data-vv-as="roomName + 'の要介護3'")
      span 円
  b-td
    .d-flex.flex-row.align-items-center
      b-form-input.mr-1(v-model.number="_value.careLevel_4"
        :name="'usage-fees-tokuyo-' + roomId + '-care-level-4'"
        :maxlength="10" :class="[ { noinput: _value.careLevel_4 == null } ]"
        v-validate="{ required: true, max: 10 }" :data-vv-as="roomName + 'の要介護4'")
      span 円
  b-td
    .d-flex.flex-row.align-items-center
      b-form-input.mr-1(v-model.number="_value.careLevel_5"
        :name="'usage-fees-tokuyo-' + roomId + '-care-level-5'"
        :maxlength="10" :class="[ { noinput: _value.careLevel_5 == null } ]"
        v-validate="{ required: true, max: 10 }" :data-vv-as="roomName + 'の要介護5'")
      span 円
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

import { PaymentCeiling } from "@/commons/services/WaiterRecruitments";

/**
 * ### 料金シミュレーション(特養タイプ) 部屋料金コンポーネント
 */
@Component({})
export default class UsageFeesTokuyoLivingCostsTableRow extends Vue {
  /** 親コンポーネントのバリデーターをInjectionする */
  @Inject("$validator") $validator!: Validator;

  @Prop()
  value!: PaymentCeiling;

  @Prop()
  roomId!: string;
  @Prop()
  roomName!: string;

  get _value(): PaymentCeiling {
    return this.value;
  }

  set _value(newValue: PaymentCeiling) {
    this.$emit("input", newValue);
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.usage-fees-tokuyo-care-insurance-service-costs-table-row {
  .room-name {
    width: 140px;
  }

  .noinput {
    background-color: $bg-require-input !important;
    &::placeholder {
      color: rgb(117, 117, 117);
    }
  }
}
</style>
